import updateConfigurationInfoState from '@hooks/configuration/updateConfigurationInfoState';

const useUpdateConfigurationInfoState = (id) => updateConfigurationInfoState(id);

export default useUpdateConfigurationInfoState;
